// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export const addressTypographyStyles: TypographyPresentationProps = {
    forwardAs: "p",
    size: 14,
    weight: "normal",
    lineHeight: "22px",
};

addressInfoDisplayStyles.customerNameText = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.firstNameText = {
    ...mergeWithCss(addressTypographyStyles, {
        css: css`
            display: inline-block;
        `,
    }),
};

addressInfoDisplayStyles.lastNameText = {
    ...mergeWithCss(addressTypographyStyles, {
        css: css`
            display: inline-block;
            padding-left: 4px;
        `,
    }),
};

addressInfoDisplayStyles.attentionText = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.companyNameText = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.address1Text = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.address2Text = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.address3Text = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.address4Text = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.cityStatePostalCodeText = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.cityText = {
    ...addressTypographyStyles,
    forwardAs: "span",
};

addressInfoDisplayStyles.stateText = {
    ...addressTypographyStyles,
    forwardAs: "span",
};

addressInfoDisplayStyles.postalCodeText = {
    ...addressTypographyStyles,
    forwardAs: "span",
};

addressInfoDisplayStyles.countryText = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.phoneText = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.emailText = {
    ...addressTypographyStyles,
};

addressInfoDisplayStyles.faxText = {
    ...addressTypographyStyles,
};
